import { useEffect } from 'react';
import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../useFetch';
import { useNavigate } from 'react-router-dom';


export default function useHandleBillingById(locationId, taskId) {
    const navigate = useNavigate()
        , fetch = useFetch(navigate);


    const { data, error, mutate } = useSWR(`${apiBaseURL}/api/Hours/billing?locationId=${locationId}&taskId=${taskId}`, {
        onSuccess: (data) => console.log('Billing code by id fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    useEffect(() => {
        if (locationId && taskId) {
            mutate();
        }
    }, [locationId, taskId, mutate]);

    const billingAndWorkArr = data?.data?.codes?.map((x) => ({
        name: `${x.name} - ${x.description}`,
        id: x.name,
        code: x.code,
        projectId: x.projectId,
    })) 
    const billingType = data?.data?.type;
    return {
        billingAndWorkArr,
        billingType,
        error,
        mutate,
    }
}